import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { Field, reduxForm } from "redux-form";

import routes from "../routes";

import { Button } from "../components/Form";
import { TextLink } from "../components";

import {
  required,
  requiredCustom,
  email,
  minLengthPassword,
  maxLengthPassword
} from "../lib/validation";

import { renderInput, renderCheckbox } from "../components/Form";

import { signUp } from "../auth/actions";

const requiredPolicy = requiredCustom(
  "Musisz zaakceptować politykę prywatności"
);
const minLengthPassword8 = minLengthPassword(8);
const maxLengthPassword250 = maxLengthPassword(250);

class SignUpForm extends Component {
  submit = values => {
    const { signUp, history } = this.props;
    return signUp(values).then(() => {
      history.push(routes.settings);
    });
  };

  render() {
    const { handleSubmit, submitting, error } = this.props;
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        <Field
          name="email"
          component={renderInput}
          type="text"
          placeholder="Email"
          validate={[required, email]}
        />
        <Field
          name="password"
          component={renderInput}
          type="password"
          placeholder="Hasło"
          validate={[required, minLengthPassword8, maxLengthPassword250]}
        />
        <Field
          name="privacy"
          component={renderCheckbox}
          label={
            <div>
              Akceptuję{" "}
              <TextLink
                to="https://opiekujsie.pl/polityka-prywatnosci"
                target="_blank"
              >
                Politykę Prywatności
              </TextLink>
            </div>
          }
          validate={[requiredPolicy]}
        />
        {error && <Error>{error}</Error>}

        <Button loading={submitting} color="primary" type="submit">
          Zarejestruj się!
        </Button>
      </Form>
    );
  }
}

const Error = styled.div.attrs({ className: "text-danger" })`
  width: 100%;
  font-size: 12px;
  margin-bottom: 20px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  width: 300px;
  margin: 40px 0;

  @media (max-width: 400px) {
    width: 100%;
  }
`;

SignUpForm = reduxForm({
  form: "singUpForm"
})(SignUpForm);

SignUpForm = connect(null, { signUp })(SignUpForm);
SignUpForm = withRouter(SignUpForm);

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/auth/SignUpForm.js